import { useState } from "react";

export const faqs = [
  {
    q: "How do I get an expedited passport in Sioux Falls, South Dakota?",
    a: "Sioux Falls residents can use Fast Passport Center for 2–9 day expedited processing. Submit your application, visit a local acceptance facility, then ship your documents to us overnight. We handle the agency submission — no trip to Minneapolis required.",
  },
  {
    q: "Where is the nearest passport agency to Sioux Falls?",
    a: "The Minneapolis Passport Agency (212 3rd Ave S, Minneapolis, MN) is approximately 270 miles northeast of Sioux Falls via I-90. It requires an appointment for genuine emergencies only. Fast Passport Center eliminates that trip for most applicants.",
  },
  {
    q: "What is the fastest way to get a passport in Sioux Falls?",
    a: "For true emergencies (travel within 72 hours), you may qualify for same-day processing via the Minneapolis agency. For most travelers, Fast Passport Center offers 2–9 day processing without requiring you to leave Sioux Falls.",
  },
  {
    q: "Can I get a passport at the Sioux Falls post office?",
    a: "Yes — Sioux Falls post offices serve as acceptance facilities where you submit your DS-11 or DS-82 application, photos, and supporting documents. However, routine postal processing takes 6–11 weeks. Fast Passport Center can expedite this to 2–9 days.",
  },
  {
    q: "How long does passport renewal take for Sioux Falls residents?",
    a: "Routine renewal via USPS takes 6–11 weeks from Sioux Falls. Expedited via post office is 3–5 weeks. Fast Passport Center offers 2–9 business day processing using our registered courier submission channels.",
  },
  {
    q: "Does Sioux Falls have a passport agency?",
    a: "Sioux Falls does not have a regional passport agency. The nearest full-service agency is in Minneapolis, MN (270+ miles). Acceptance facilities (post offices, clerk offices) can accept applications but cannot process them quickly.",
  },
  {
    q: "How much does it cost to get a passport in Sioux Falls?",
    a: "Government fees are $130 for adult renewal and $165 for new adult passports (plus $35 execution fee at acceptance facilities). Fast Passport Center charges an additional service fee for agent review, courier submission, and expedited processing.",
  },
  {
    q: "Can I use Fast Passport Center if I live in Brandon or Harrisburg?",
    a: "Absolutely. We serve all of Minnehaha County, Lincoln County, and the surrounding Sioux Falls metro area. Brandon, Harrisburg, Tea, Hartford, and surrounding communities all qualify for our full passport services.",
  },
];

export default function FAQSection() {
  const [open, setOpen] = useState<number | null>(null);

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">FAQ</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Frequently Asked Questions — Sioux Falls Passports
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base">
            Everything Sioux Falls residents ask about expedited passport services. Don&apos;t see your question? Call us directly.
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div key={i} className="border border-gray-200 rounded-lg overflow-hidden">
              <button
                onClick={() => setOpen(open === i ? null : i)}
                className="w-full flex items-center justify-between px-5 py-4 text-left hover:bg-[#F7F8FA] transition-colors"
              >
                <h4>
                  <a className="font-semibold text-[#1A365D] text-sm pr-4">{faq.q}</a>
                </h4>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i className={`${open === i ? "ri-subtract-line" : "ri-add-line"} text-[#1A365D] text-lg`}></i>
                </div>
              </button>
              {open === i && (
                <div className="px-5 pb-4">
                  <p className="text-gray-500 text-sm leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}